import type { MouseEventHandler } from 'react';
import React, { forwardRef } from 'react';

import { Button } from '@sravni/react-design-system';

import styles from './styles.module.scss';

interface IProps {
  text?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}

export const AnchorButton = forwardRef<HTMLButtonElement, IProps>(({ text = 'Показать еще', onClick }, ref) => (
  <Button ref={ref} className={styles.button} variant="outlined" onClick={onClick} block>
    {text}
  </Button>
));

AnchorButton.displayName = 'AnchorButton';
